import React from "react";

// import "./FtLineUp.scss";
import NextImage from "../NextImage";

const FtLineUp = ({ home, away }) => {

  const baseURL = process.env.REACT_APP_BASE_URL ?? "https://ipublisher-microservices.6lgx.com";

  const renderSubstitutions = (substitutions) =>
    substitutions?.map((sub, index) => (
      <li key={`${sub?.min}-${index}`}>
        <span className="ft_lineup_num">{sub?.min}&lsquo;</span>
        <div className="teams_wrap">
          <div className="teams-name">
            <span className="active team_name">{sub?.p_in_nm}</span>
            <span className="team_name">{sub?.p_out_nm}</span>
          </div>
          <div className="teams-logo">
            <NextImage
              src={`${baseURL}/public/assets/images/svg/updown-arrow2.svg`}
              height={16}
              width={16}
              alt="teamLogo"
              priority={false}
            />
          </div>
        </div>
      </li>
    ));

  return (
    <div className="football_lineup_box">
      <div className="ft_lineup_columns">
        <ul className="ft_list_lineup">{renderSubstitutions(home)}</ul>
        <ul className="ft_list_lineup">{renderSubstitutions(away)}</ul>
      </div>
    </div>
  );
};

export default FtLineUp;
